import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";

/**
 * GA4 não detecta mudanças de rota em SPAs automaticamente — dispara page_view
 * manualmente a cada troca de pathname. Chamar uma única vez, no componente raiz
 * autenticado (ver AuthProvider.tsx).
 *
 * `enabled` deve refletir a checagem de auth do Keycloak já concluída (RN-09/CA-10:
 * nenhum evento antes disso) — não se o usuário está de fato autenticado, já que
 * páginas públicas (ex: /login) também devem gerar page_view.
 */
export const usePageTracking = (enabled: boolean) => {
  const location = useLocation();

  useEffect(() => {
    if (!enabled) return;
    trackPageView(location.pathname, document.title);
  }, [enabled, location.pathname]);
};
